export default __webpack_public_path__ + "static/media/plus.e37fae5c.svg";